// ProtectedRoute.tsx
import { NothingFoundBackground } from '@/components/NothingFoundBackground/NothingFoundBackground';
import { useIdentity } from '@/providers/identity/IdentityProvider';
import { Role } from '@/types/role';
import { Outlet } from 'react-router-dom';

interface DevRouteProps {}

const DevRoute: React.FC<DevRouteProps> = () => {
    const { roles } = useIdentity();

    return roles?.includes(Role.Dev) ? <Outlet /> : <NothingFoundBackground />;
};

export default DevRoute;
